export const ar = {
  nav: {
    home: 'الرئيسية',
    about: 'عن الكلية',
    programs: 'البرامج',
    services: 'الخدمات',
    courses: 'الدورات',
    team: 'فريق العمل',
    news: 'الأخبار',
    contact: 'تواصل معنا',
    blog: 'المدونة',
  },
  hero: {
    badge: 'مؤسسة تعليمية معتمدة دولياً',
    title: 'كلية ساي التعليمية اليمنية الصينية',
    subtitle: 'ريادة في تعليم اللغة الصينية في اليمن',
    description: 'نقدم برامج تعليمية مبتكرة تجمع بين إتقان اللغة وفهم الثقافة الصينية لفتح آفاق عالمية للطلاب اليمنيين',
    cta1: 'استكشف البرامج',
    cta2: 'تواصل معنا',
  },
  trust: {
    students: 'طالب',
    success: 'نسبة النجاح',
    scholarships: 'منحة دراسية',
  },
  features: {
    title: 'لماذا كلية ساي؟',
    feature1Title: 'تعليم تفاعلي',
    feature1Desc: 'مناهج حديثة تركز على النطق والمحادثة',
    feature2Title: 'شهادات دولية',
    feature2Desc: 'مركز تأهيل لاختبارات HSK و YCT',
    feature3Title: 'تبادل ثقافي',
    feature3Desc: 'برامج لتعريف الطلاب بالحياة والفرص في الصين',
  },
  programs: {
    title: 'برامجنا الأكاديمية',
    subtitle: 'اختر البرنامج المناسب لأهدافك التعليمية والمهنية',
    viewAll: 'عرض الكل',
    program1Title: 'برنامج اللغة الصينية للبالغين',
    program1Desc: 'دبلوم مكثف يبدأ من الأساسيات حتى الإتقان الكامل، مصمم خصيصاً للمهنيين والطلاب الجامعيين في اليمن',
    program2Title: 'برنامج اللغة الصينية للأطفال واليافعين (YCT)',
    program2Desc: 'تعليم مرح وتفاعلي باستخدام الوسائط المتعددة لمساعدة الجيل الناشئ على اكتساب لغة ثانية بسهولة',
    program3Title: 'الصينية للأعمال (Business Chinese)',
    program3Desc: 'دورة مخصصة للتجار والشركات اليمنية التي تتعامل مع الأسواق الصينية، تشمل مصطلحات التجارة وآداب العمل',
    duration: 'المدة',
    level: 'المستوى',
    certificate: 'الشهادة',
  },
  about: {
    title: 'عن كلية ساي',
    subtitle: 'رحلتنا في بناء جسور التواصل بين اليمن والصين',
    whoWeAre: 'من نحن؟',
    whoWeAreDesc: 'كلية ساي (SAI) هي مؤسسة تعليمية رائدة في صنعاء، تهدف إلى مد جسور التواصل الثقافي والعلمي بين اليمن والصين. نحن نؤمن أن تعلم اللغة هو المفتاح لفهم القوة الاقتصادية القادمة.',
    vision: 'رؤيتنا',
    visionDesc: 'أن نصبح المرجع الأول والمنصة الأهم لتعليم اللغة الصينية في اليمن والمنطقة.',
    values: 'قيمنا',
    value1: 'الجودة الأكاديمية',
    value2: 'الابتكار في التدريس',
    value3: 'النزاهة الثقافية',
  },
  news: {
    title: 'الأخبار والفعاليات',
    subtitle: 'آخر الأخبار والأحداث الأكاديمية في كلية ساي',
    readMore: 'اقرأ المزيد',
    cat1: 'برامج أكاديمية',
    cat2: 'منح دراسية',
    cat3: 'فعاليات ثقافية',
    news1Title: 'افتتاح دورة HSK المكثفة',
    news1Desc: 'انطلاق دورة تحضيرية مكثفة لاختبار HSK المستوى 4 و 5 بإشراف أساتذة صينيين متخصصين',
    news1Date: '15 يناير 2025',
    news2Title: 'منح دراسية جديدة للطلاب المتفوقين',
    news2Desc: 'إعلان عن 15 منحة دراسية كاملة للدراسة في الجامعات الصينية المرموقة للعام الدراسي القادم',
    news2Date: '10 يناير 2025',
    news3Title: 'ورشة عمل الثقافة الصينية',
    news3Desc: 'ورشة تفاعلية حول فنون الخط الصيني وتقاليد الشاي مع خبراء من معهد كونفوشيوس',
    news3Date: '5 يناير 2025',
  },
  testimonials: {
    badge: 'آراء الطلاب',
    title: 'شهادات وتقييمات طلابنا',
    subtitle: 'ماذا يقول طلابنا عن تجربتهم في كلية ساي',
    student1Name: 'أحمد محمد الشامي',
    student1Role: 'خريج برنامج اللغة الصينية',
    student1Text: 'كلية ساي غيرت حياتي تماماً. بفضل البرنامج المكثف، حصلت على منحة دراسية في جامعة بكين وأصبحت الآن مترجماً معتمداً. المدرسون محترفون والمنهج عملي جداً.',
    student2Name: 'فاطمة علي الحداد',
    student2Role: 'طالبة في برنامج الأعمال',
    student2Text: 'أعمل في شركة استيراد وتصدير، وبرنامج الصينية للأعمال ساعدني كثيراً في التواصل مع الشركاء الصينيين. الآن أستطيع إجراء المفاوضات بثقة تامة.',
    student3Name: 'خالد سعيد المقطري',
    student3Role: 'طالب في السنة الثانية',
    student3Text: 'البيئة التعليمية في كلية ساي رائعة. الفصول مجهزة بأحدث التقنيات، والأنشطة الثقافية تجعل التعلم ممتعاً. أنصح كل من يريد تعلم الصينية بالانضمام.',
  },
  contact: {
    title: 'تواصل معنا',
    subtitle: 'نحن هنا للإجابة على استفساراتك ومساعدتك في بداية رحلتك التعليمية',
    address: 'العنوان',
    addressText: 'جولة ريماس، شارع حدة، صنعاء – الجمهورية اليمنية',
    phone: 'الهاتف',
    phone1: '00967775182228',
    phone2: '009671260640',
    email: 'البريد الإلكتروني',
    emailText: 'info@sai-college.com',
    hours: 'ساعات العمل',
    hoursText: 'من السبت إلى الخميس، من 8:00 صباحاً حتى 8:00 مساءً',
    formTitle: 'أرسل لنا رسالة',
    name: 'الاسم',
    emailLabel: 'البريد الإلكتروني',
    subject: 'الموضوع',
    message: 'الرسالة',
    send: 'إرسال',
    sending: 'جاري الإرسال...',
    success: 'تم إرسال رسالتك بنجاح!',
    error: 'حدث خطأ. يرجى المحاولة مرة أخرى.',
  },
  visitBooking: {
    badge: 'احجز موعدك الآن',
    title: 'زيارة الكلية',
    subtitle: 'احجز موعداً لزيارة كلية ساي واستكشف مرافقنا الحديثة، التقِ بأساتذتنا، واحصل على جولة تعريفية شاملة',
    formTitle: 'احجز موعد زيارة الكلية',
    formSubtitle: 'املأ النموذج وسنتواصل معك لتأكيد الموعد',
    fullName: 'الاسم الكامل',
    phone: 'رقم الهاتف',
    email: 'البريد الإلكتروني',
    visitDate: 'تاريخ الزيارة المطلوب',
    visitTime: 'الوقت المفضل',
    purpose: 'الغرض من الزيارة',
    numberOfVisitors: 'عدد الزوار',
    notes: 'ملاحظات إضافية',
    selectTime: 'اختر الوقت',
    morning: 'صباحي (8:00 - 12:00)',
    afternoon: 'ظهري (12:00 - 16:00)',
    evening: 'مسائي (16:00 - 20:00)',
    selectPurpose: 'اختر الغرض',
    tour: 'جولة تعريفية',
    admission: 'استفسار عن القبول',
    interview: 'مقابلة أكاديمية',
    facilities: 'زيارة المرافق',
    other: 'أخرى',
    availableDays: 'متاح من السبت إلى الخميس',
    fridayClosed: 'عذراً، الكلية مغلقة يوم الجمعة',
    submit: 'تأكيد الحجز',
    submitting: 'جاري الإرسال...',
    successTitle: 'تم تأكيد الحجز بنجاح!',
    successMessage: 'شكراً لك على حجز موعد زيارة كلية ساي. سنتواصل معك قريباً لتأكيد التفاصيل.',
    bookingReference: 'رقم الحجز المرجعي',
    bookAnother: 'حجز موعد آخر',
    infoNote: 'سيتم التواصل معك خلال 24 ساعة لتأكيد موعد الزيارة. في حالة عدم توفر الموعد المطلوب، سنقترح عليك بدائل مناسبة.',
    charactersLimit: 'حرف',
  },
  aboutPage: {
    title: 'عن الكلية',
    whoWeAre: 'من نحن؟',
    whoWeAreDesc: 'كلية ساي (SAI) هي مؤسسة تعليمية رائدة في صنعاء، تهدف إلى مد جسور التواصل الثقافي والعلمي بين اليمن والصين. نحن نؤمن أن تعلم اللغة هو المفتاح لفهم القوة الاقتصادية القادمة.',
    vision: 'رؤيتنا',
    visionDesc: 'أن نصبح المرجع الأول والمنصة الأهم لتعليم اللغة الصينية في اليمن والمنطقة.',
    mission: 'رسالتنا',
    missionDesc: 'تقديم تعليم عالي الجودة للغة الصينية والثقافة، وتمكين الطلاب اليمنيين من الاستفادة من الفرص الأكاديمية والمهنية في الصين والعالم.',
    values: 'قيمنا',
    value1: 'الجودة الأكاديمية',
    value1Desc: 'نلتزم بأعلى معايير التعليم الدولية',
    value2: 'الابتكار في التدريس',
    value2Desc: 'نستخدم أحدث الأساليب التعليمية التفاعلية',
    value3: 'النزاهة الثقافية',
    value3Desc: 'نحترم ونعزز التبادل الثقافي الأصيل',
  },
  servicesPage: {
    title: 'خدماتنا',
    subtitle: 'نقدم مجموعة شاملة من الخدمات التعليمية والاستشارية',
    service1Title: 'الاستشارات التعليمية',
    service1Desc: 'نساعد الطلاب اليمنيين في اختيار التخصصات المناسبة والجامعات الصينية المرموقة.',
    service2Title: 'الترجمة والتعريب',
    service2Desc: 'خدمات ترجمة احترافية (صيني-عربي-إنجليزي) للشركات والمؤسسات العاملة في اليمن.',
    service3Title: 'التدريب الثقافي',
    service3Desc: 'ورش عمل حول الثقافة الصينية، فنون الخط، وتقاليد الشاي لتعميق الفهم الثقافي.',
  },
  scholarships: {
    badge: 'المنح المتاحة',
    title: 'المنح الدراسية',
    subtitle: 'استثمر في مستقبلك مع منح كلية ساي للتميز الأكاديمي',
    s1Title: 'منحة التفوق الأكاديمي',
    s1Desc: 'منحة كاملة للطلاب المتفوقين أكاديمياً للدراسة في أفضل الجامعات الصينية مع تغطية شاملة للرسوم والسكن.',
    s1Value: 'منحة كاملة 100%',
    s1Deadline: 'آخر موعد: مارس 2025',
    s1Cond1: 'معدل تراكمي لا يقل عن 90%',
    s1Cond2: 'اجتياز اختبار HSK المستوى 4',
    s1Cond3: 'خطاب توصية من أستاذين',
    s2Title: 'منحة HSK للتميز اللغوي',
    s2Desc: 'منحة جزئية للطلاب الذين يحققون درجات عالية في اختبارات HSK لتشجيع التميز في إتقان اللغة الصينية.',
    s2Value: 'تغطية 75%',
    s2Deadline: 'آخر موعد: يونيو 2025',
    s2Cond1: 'اجتياز HSK المستوى 5 بدرجة 250+',
    s2Cond2: 'طالب منتظم في كلية ساي',
    s2Cond3: 'مقال عن أهداف التعلم',
    s3Title: 'منحة الأعمال والتجارة',
    s3Desc: 'منحة مخصصة لرجال الأعمال والمهنيين الراغبين في تعلم الصينية للأعمال وتوسيع شراكاتهم التجارية.',
    s3Value: 'تغطية 50%',
    s3Deadline: 'آخر موعد: سبتمبر 2025',
    s3Cond1: 'خبرة عملية لا تقل عن سنتين',
    s3Cond2: 'خطة عمل واضحة مع الصين',
    s3Cond3: 'مستوى أساسي في اللغة الصينية',
    s4Title: 'منحة التبادل الثقافي الدولي',
    s4Desc: 'منحة للطلاب المتميزين للمشاركة في برامج التبادل الثقافي مع الجامعات الصينية لمدة فصل دراسي كامل.',
    s4Value: 'تغطية كاملة + سفر',
    s4Deadline: 'آخر موعد: يناير 2026',
    s4Cond1: 'إتمام سنة دراسية في كلية ساي',
    s4Cond2: 'مشاركة فعالة في الأنشطة الثقافية',
    s4Cond3: 'اجتياز المقابلة الشخصية',
    note: 'للتقديم على أي من المنح الدراسية، يرجى زيارة مكتب القبول أو التواصل معنا عبر البريد الإلكتروني.',
  },
  gallery: {
    badge: 'معرض الصور',
    title: 'لحظات لا تُنسى',
    subtitle: 'استكشف أبرز فعالياتنا وأنشطتنا الطلابية في كلية ساي',
    img1Title: 'فصل دراسي تفاعلي',
    img1Date: 'يناير 2025',
    img2Title: 'ورشة الخط الصيني',
    img2Date: 'ديسمبر 2024',
    img3Title: 'حفل التخرج السنوي',
    img3Date: 'نوفمبر 2024',
    img4Title: 'مهرجان التبادل الثقافي',
    img4Date: 'أكتوبر 2024',
    img5Title: 'مؤتمر الطلاب الأكاديمي',
    img5Date: 'سبتمبر 2024',
    img6Title: 'رحلة إلى المتحف الصيني',
    img6Date: 'أغسطس 2024',
  },
  faq: {
    badge: 'دليلك الشامل',
    title: 'الأسئلة الشائعة',
    subtitle: 'كل ما تحتاج معرفته عن الدراسة في كلية ساي التعليمية',
    cat1: 'القبول والتسجيل',
    q1: 'ما هي شروط القبول في كلية ساي؟',
    a1: 'يشترط للقبول في كلية ساي أن يكون المتقدم حاصلاً على شهادة الثانوية العامة كحد أدنى. لا يُشترط وجود معرفة مسبقة باللغة الصينية، حيث تبدأ برامجنا من المستوى التأسيسي. يتم تقديم طلب القبول عبر مكتب التسجيل أو إلكترونياً.',
    q2: 'متى تبدأ فترة التسجيل للفصل الدراسي القادم؟',
    a2: 'يفتح باب التسجيل للفصل الأول في شهر أغسطس من كل عام، وللفصل الثاني في شهر يناير. ننصح بالتسجيل المبكر لضمان الحصول على مقعد، حيث أن الأماكن محدودة في بعض البرامج.',
    q3: 'هل يمكنني التسجيل في أكثر من برنامج في نفس الوقت؟',
    a3: 'نعم، يمكنك التسجيل في برنامج أساسي وبرنامج إضافي مثل الصينية للأعمال أو ورش العمل الثقافية، بشرط عدم تعارض المواعيد. فريق الإرشاد الأكاديمي سيساعدك في اختيار الجدول المناسب.',
    q4: 'هل تقبلون الطلاب من خارج صنعاء؟',
    a4: 'بالتأكيد! نرحب بالطلاب من جميع المحافظات اليمنية. نوفر خدمات إرشادية للطلاب القادمين من خارج صنعاء لمساعدتهم في إيجاد سكن مناسب بالقرب من الكلية.',
    cat2: 'الرسوم والمنح الدراسية',
    q5: 'ما هي تكلفة الدراسة في كلية ساي؟',
    a5: 'تختلف الرسوم حسب البرنامج المختار. برنامج الدبلوم المكثف يبدأ من رسوم تنافسية مقارنة بالمؤسسات المماثلة. نوفر أيضاً خطط دفع مرنة على أقساط شهرية لتسهيل العملية على الطلاب.',
    q6: 'كيف يمكنني التقديم على المنح الدراسية؟',
    a6: 'يمكنك التقديم على المنح الدراسية من خلال تعبئة نموذج التقديم المتاح في مكتب القبول أو عبر موقعنا الإلكتروني. يجب إرفاق الوثائق المطلوبة مثل الشهادات الأكاديمية ونتائج اختبار HSK وخطابات التوصية.',
    q7: 'هل توجد خصومات للتسجيل المبكر أو للمجموعات؟',
    a7: 'نعم، نقدم خصم 10% للتسجيل المبكر قبل شهر من بدء الفصل الدراسي، وخصم 15% للمجموعات المكونة من 3 طلاب أو أكثر. كما نقدم خصومات خاصة لأبناء الموظفين في الشركات الشريكة.',
    cat3: 'الحياة الأكاديمية',
    q8: 'ما هي مدة برنامج الدبلوم المكثف؟',
    a8: 'يمتد برنامج الدبلوم المكثف لمدة عامين دراسيين (4 فصول دراسية). يتضمن البرنامج دراسة اللغة الصينية من المستوى المبتدئ حتى المتقدم، بالإضافة إلى مواد الثقافة والترجمة والتحضير لاختبارات HSK.',
    q9: 'هل يتم التدريس باللغة العربية أم الصينية؟',
    a9: 'في المستويات الأولى يتم التدريس بمزيج من العربية والصينية لضمان الفهم الكامل. مع تقدم الطالب، تزداد نسبة استخدام اللغة الصينية تدريجياً حتى تصبح لغة التدريس الأساسية في المستويات المتقدمة.',
    q10: 'هل تمنح الكلية شهادات معتمدة؟',
    a10: 'نعم، تمنح كلية ساي شهادات معتمدة محلياً ودولياً. كما أننا مركز معتمد لاختبارات HSK و YCT، مما يتيح للطلاب الحصول على شهادات إتقان اللغة الصينية المعترف بها عالمياً.',
    ctaTitle: 'لم تجد إجابة لسؤالك؟',
    ctaDesc: 'فريقنا جاهز للإجابة على جميع استفساراتك ومساعدتك في رحلتك التعليمية',
    ctaButton: 'تواصل معنا',
  },
  team: {
    hero: {
      title: 'فريق العمل المتميز',
      subtitle: 'نخبة من الأساتذة والموظفين ذوي الخبرة العالية في التعليم الأكاديمي والتعاون الدولي'
    },
    contact: {
      email: 'البريد الإلكتروني',
      linkedin: 'لينكدإن'
    },
    noResults: 'لا توجد نتائج',
    cta: {
      title: 'انضم إلى عائلتنا الأكاديمية',
      description: 'نحن نبحث دائماً عن المواهب المتميزة للانضمام إلى فريقنا. تواصل معنا لمعرفة الفرص المتاحة',
      contactButton: 'تواصل معنا',
      registerButton: 'سجل الآن'
    }
  },
};

export default ar;